import { userPickedAvalancheOverlay } from '../state/avalanche.ts';
import { AVALANCHE_OVERLAY_MODES, overlay, type OverlayMode } from '../state/store.ts';

const SIMPLE_VIEW_BUTTONS: { mode: OverlayMode; label: string }[] = [
  { mode: 'natural', label: 'Natural' },
  { mode: 'snowDepth', label: 'Snow depth' },
  { mode: 'windLoading', label: 'Wind loading' },
  { mode: 'stability', label: 'Stability' },
  { mode: 'problem', label: 'Problem' },
  { mode: 'avNet', label: 'Avalanches' },
];

/** Simple mode's "View" section: the six overlays worth showing without a data background.
 * The legend for whichever is active is drawn over the 3D view itself (`Legend.tsx`). */
export function SimpleViewPanel() {
  return (
    <section class="panel-section">
      <h2>View</h2>
      <div class="segmented">
        {SIMPLE_VIEW_BUTTONS.map((o) => (
          <button
            key={o.mode}
            class={overlay.value === o.mode ? 'active' : ''}
            onClick={() => {
              overlay.value = o.mode;
              if (AVALANCHE_OVERLAY_MODES.has(o.mode)) userPickedAvalancheOverlay.value = true;
            }}
          >
            {o.label}
          </button>
        ))}
      </div>
    </section>
  );
}
